import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { SettingsService } from '../../../../../core/services/settings.service';

import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css'],
  standalone: true,
  imports: [ReactiveFormsModule, FormsModule],
})
export class ChangePasswordComponent {
  passwordForm: FormGroup;
  error: string | null = null;
  @ViewChild('successModal') successModalTemplate: any;
  successMessage: string = '';

  errorMessage: string = '';

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private settingsService: SettingsService,
    private modalService: NgbModal
  ) {
    this.passwordForm = this.fb.group({
      currpwd: ['', Validators.required],
      newpwd: ['', Validators.required],
      confirmnewpwd: ['', Validators.required]
    });
  }

  showError(): boolean {
    const { currpwd, newpwd, confirmnewpwd } = this.passwordForm.value;
    if (!currpwd || !newpwd || !confirmnewpwd) {
      this.error = 'All fields are required';
      return true;
    } else if (newpwd !== confirmnewpwd) {
      this.error = 'Passwords do not match';
      return true;
    }

    this.error = null;
    return false;
  }

  save(): void {
    if (this.passwordForm.invalid || this.showError()) return;

    const { currpwd, newpwd } = this.passwordForm.value;
    this.settingsService.changePassword(currpwd, newpwd).subscribe({
      next: () => {
        this.errorMessage = '';
        this.successMessage = 'Password updated successfully';
        this.modalService.open(this.successModalTemplate, { centered: true });
        this.activeModal.close();
      },
      error: (err) => {
        if (err.error && err?.error?.error?.message) {
          this.errorMessage = err?.error?.error?.message;
        } else {
          this.errorMessage = 'An unexpected error occurred. Please try again.';
        }
        console.error(err);
      }
    });
  }

  cancel(): void {
    this.close();
  }

  private close(): void {
    this.activeModal.close();
  }
}
